export default __webpack_public_path__ + "static/media/project-mentoring.2435aeb2.png";